const localStorageKey = "plan";

export const planLocalStorageItems = {
    googleMapsSession: "google-maps-session" as const,
};

type PlanStorageItems = {
    [planLocalStorageItems.googleMapsSession]: { apiKey: string; session: string; expiry: number } | null;
};

function generatePlanLocalStorageKey() {
    return `${localStorageKey}`;
}

/** Gets plan items, Partial as certain keys could not be set yet */
function getPlanLocalStorageItems(): Partial<PlanStorageItems> {
    const planItemsJson = localStorage.getItem(generatePlanLocalStorageKey());
    if (planItemsJson == null) {
        return {};
    }
    return JSON.parse(planItemsJson);
}

/** Type safe planLocalStorage management. get() calls planLocalStorage.getItem() and set() calls planLocalStorage.setItem() */
export const planLocalStorageManager = {
    get: <T extends keyof PlanStorageItems>(key: T) => {
        const planItems = getPlanLocalStorageItems();
        return planItems?.[key];
    },
    set: <T extends keyof PlanStorageItems>(key: T, item: PlanStorageItems[typeof key]): void => {
        // If plan items do not exist use blank object
        const planItems = getPlanLocalStorageItems() ?? {};
        planItems[key] = item;
        localStorage.setItem(generatePlanLocalStorageKey(), JSON.stringify(planItems));
    },
};
